export default __webpack_public_path__ + "static/spotlight-anatomy-light-4a3643a5ee31236e7c76767ce3d2a1dc0a99a96859dfbe2528047def3f4b5025.png";